/**
 * Takes care of removing the loading screen if it's still visible.
 * The loading screen HTML is added to our index.html entry point today to ensure it shows immediately,
 * even before Vue is bootstrapping.
 *
 * Ensure this function is called at least once during app load.
 */

/*
  Must match the `transition: stroke-dashoffset <duration> ease` set on
  .loading-ring-progress in index.html. The last reportLoadingStepComplete
  call (see loadingProgress.ts) and the appLoaded commit that triggers this
  removal happen in the same synchronous stretch of bootstrap.ts, so without
  this delay the browser never gets a chance to paint the ring reaching 100%
  (or animate the transition to it) before the element is torn down.
*/
const RING_COMPLETION_TRANSITION_MS = 300;

export function handleLoadingScreenRemoval() {
  const loadingStyles = document.getElementById('loadingStyles');
  const loadingElement = document.getElementById('loadingElement');
  if (!loadingStyles && !loadingElement) return;

  // Wait a frame for the final progress update to be committed, then let
  // the transition play out, before actually tearing down the DOM.
  requestAnimationFrame(() => {
    setTimeout(() => {
      if (loadingStyles?.parentElement) {
        loadingStyles.parentElement.removeChild(loadingStyles);
      }
      if (loadingElement?.parentElement) {
        loadingElement.parentElement.removeChild(loadingElement);
      }
    }, RING_COMPLETION_TRANSITION_MS);
  });
}
